module.exports = __webpack_public_path__ + "046d153973dbdebca3e558d5818836ae.png";